<mat-progress-bar class="progress-bar" mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
<div class="container" fxLayout="row wrap">
    <div fxFlex="100">
        <div fxLayout="row wrap" class="p-l-5">
            <div fxFlex="100">
                <img [src]="practiceLogoUrl" height="45">
            </div>
        </div>
        <div fxLayout="row wrap" *ngIf="this.drawingDetails.id" fxLayout.xs="column-reverse"
            fxLayout.sm="column-reverse" class="section1-container" fxLayoutAlign="space-between start">
            <div class="p-l-r-5" fxLayout="column" fxFlex.gt-sm="45" fxFlex="100" fxLayoutAlign="space-between start">
                <h1 fxLayout="row" class="text-black">{{drawingDetails.title}}</h1>
                <h4 fxLayout="row" class="text-black desc">{{drawingDetails.detailedDescription}}</h4>
            </div>
            <div class="p-l-5" fxFlex.gt-sm="55" fxFlex="100">
                <img [src]="drawingDetails.heroImageURL" class="drawing-img">
            </div>
        </div>
    </div>
    <div fxLayout="row wrap" fxLayout.xs="column-reverse" fxLayout.sm="column-reverse" class="section3-container"
        fxFlex="100">
        <div fxFlex.gt-sm="45" fxFlex="100" class="p-l-5 time-holder time-left">
            <h2 class="text-black">Time left to participate</h2>
            <div fxLayout="row wrap" class="time-container">
                <mat-card fxFlex="16" fxFlex.lt-sm="22" fxFlex.gt-sm="22" class="xsm-screen b-b-l-r-r">
                    <div class="time-header">
                        <span>{{timeleft.days}}</span>
                    </div>
                    <div class="time-footer">
                        <span>DAYS</span>
                    </div>
                </mat-card>
                <mat-card fxFlex="16" fxFlex.lt-sm="22" fxFlex.gt-sm="22" class="xsm-screen b-b-l-r-r">
                    <div class="time-header">
                        <span>{{timeleft.hours}}</span>
                    </div>
                    <div class="time-footer">
                        <span>HOURS</span>
                    </div>
                </mat-card>
                <mat-card fxFlex="16" fxFlex.lt-sm="22" fxFlex.gt-sm="22" class="b-b-l-r-r">
                    <div class="time-header">
                        <span>{{timeleft.minutes}}</span>
                    </div>
                    <div class="time-footer">
                        <span>MINUTES</span>
                    </div>
                </mat-card>
                <mat-card fxFlex="16" fxFlex.lt-sm="22" fxFlex.gt-sm="22" class="b-b-l-r-r">
                    <div class="time-header">
                        <span>{{timeleft.seconds}}</span>
                    </div>
                    <div class="time-footer">
                        <span>SECONDS</span>
                    </div>
                </mat-card>
            </div>
        </div>
        <div fxFlex.gt-sm="55" fxFlex="100" class="p-l-r-5" *ngIf="drawingDetails.runStatus ==='Not Run'">
            <h2 class="text-black">Want to redeem points to earned tickets?</h2>
            <h6 *ngIf="awardRuleDeatils">Redeem {{awardRuleDeatils.rewardValue}} {{awardRuleDeatils.reward}}s and get
                {{awardRuleDeatils.numberOfTicketsGranted}} ticket </h6>
            <form [formGroup]="redeemPointForm" (keydown.enter)="redeemPoints($event)"
                (ngSubmit)="redeemPoints($event)">
                <div fxLayout="row wrap" fxLayoutAlign="space-between start" fxFlex="100">
                    <div fxFlex.gt-sm="73" fxFlex="100">
                        <input class="points" (keydown)="hideSearchBox($event)" formControlName="points" matInput
                            placeholder="eg. 100">
                    </div>
                    <div fxFlex.gt-sm="25" fxFlex="100" class="get-detail-btn">
                        <button class="get-detail-btn" type="submit" mat-raised-button color="primary"
                            [disabled]="!redeemPointForm.valid||searchTicketLoader">SUBMIT</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- <div class="ticket-section p-l-r-5" fxFlex="100" *ngIf="isSearchTickets">
        <div class="ticket">
            <div class="ticket__content">
                <mat-card class="drawing-mat-card">
                    <div *ngIf="!rewardTicket.length">
                        <mat-progress-bar mode="indeterminate" *ngIf="searchTicketLoader" color="accent">
                        </mat-progress-bar>
                        <mat-card-content class="waiting-container" fxLayoutAlign="center center">
                            <h4 *ngIf="searchTicketLoader">{{ticketBox.loaderMsg}}</h4>
                            <h4 *ngIf="!searchTicketLoader">{{ticketBox.failMsg}}</h4>
                        </mat-card-content>
                    </div>
                    <mat-card-content *ngIf="rewardTicket.length">
                        <div fxLayout="row wrap">
                            <h4 class="ticket-title">{{ticketBox.successMsg}}</h4>
                        </div>
                        <div fxLayout="row wrap">
                            <div fxFlex.gt-sm="33.33" fxFlex.gt-md="24" fxFlex.lt-md="50" fxFlex.lt-sm="100"
                                fxFlex="100" *ngFor="let result of rewardTicket" class="ticket-container">
                                <div class="ticket-num">{{result.ticketNo}}</div>
                                <div class="ticket-email">{{result.email}}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div> -->
    <div class="ticket-section p-l-r-5" fxFlex="100" *ngIf="isSearchTickets || rewards.length">
        <div class="ticket">
            <div class="ticket__content">
                <mat-card class="drawing-mat-card">
                    <mat-card-content>
                        <div *ngIf="isSearchTickets">
                            <div *ngIf="!rewardTicket.length">
                                <mat-progress-bar mode="indeterminate" *ngIf="searchTicketLoader" color="accent">
                                </mat-progress-bar>
                                <div class="waiting-container" fxLayoutAlign="center center">
                                    <h4 *ngIf="searchTicketLoader">{{ticketBox.loaderMsg}}</h4>
                                    <h4 *ngIf="!searchTicketLoader">{{ticketBox.failMsg}}</h4>
                                </div>
                            </div>

                            <div *ngIf="rewardTicket.length">
                                <div fxLayout="row wrap">
                                    <h4 class="ticket-title">{{ticketBox.successMsg}}</h4>
                                </div>
                                <div fxLayout="row wrap">
                                    <div fxFlex.gt-sm="33.33" fxFlex.gt-md="24" fxFlex.lt-md="50" fxFlex.lt-sm="100"
                                        fxFlex="100" *ngFor="let result of rewardTicket" class="ticket-container">
                                        <div class="ticket-num">{{result.ticketNo}}</div>
                                        <div class="ticket-email">{{result.email}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="rewards.length">
                            <div fxLayout="row wrap">
                                <h4 class="ticket-title">You have earned total {{rewards.length}} tickets
                                    for this drawing</h4>
                            </div>
                            <div fxLayout="row wrap">
                                <div fxFlex.gt-sm="33.33" fxFlex.gt-md="24" fxFlex.lt-md="50" fxFlex.lt-sm="100"
                                    fxFlex="100" *ngFor="let result of rewards" class="ticket-container">
                                    <div class="ticket-num">{{result.ticketNo}}</div>
                                    <div class="ticket-email">{{result.email}}</div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <div class="section4-container" fxFlex="100">
        <div fxLayout="row wrap" fxFlex="100" class="rules-container">
            <div fxLayout="row wrap" fxLayoutAlign="center start" fxFlex="100">
                <h2 class="text-white">Rules for participation</h2>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center start">
                <mat-card fxFlex.gt-sm="16.5" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule1.png" class="rule-logo">
                        <p class="rule-desc" class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                            sed do eiusmod tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
                <mat-card fxFlex.gt-sm="16.5" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule2.png" class="rule-logo">
                        <p class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
                <mat-card fxFlex.gt-sm="16.5" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule3.png" class="rule-logo">
                        <p class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
                <mat-card fxFlex.gt-sm="16.5" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule4.png" class="rule-logo">
                        <p class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
                <mat-card fxFlex.gt-sm="16.5" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule5.png" class="rule-logo">
                        <p class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap" class="section5-container p-l-r-5" fxFlex="100">
        <div fxFlex.gt-md="20" fxFlex.gt-xs="33" fxFlex="100" class="footer-logo">
            <img [src]="practiceLogoUrl" height="45">
        </div>
        <div class="text-black" fxFlex.gt-md="30" fxFlex.gt-xs="28" fxFlex="100">
            <h3>Contact us</h3>
            hello@carecognitics.com <br />
            <a>+650.617.3425</a>
        </div>
        <div class="text-black" fxFlex.gt-md="40" fxFlex.gt-xs="38" fxFlex="100">
            <h3>Disclaimer</h3>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.
        </div>
    </div>
</div>